import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
  message: string;
  storeId: string;
  session_id?: string;
};

type ResponseType = {
  data: any;
  meta: any;
};

export const sendMessage = async (payload: APIPayload) => {
  try {
    const { storeId, ...rest } = payload;
    const response = await Axios.post(`/store/chat?store_id=${storeId}`, rest);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useSendMessage = () => {
  return useMutation<ResponseType, Error, APIPayload>({
    mutationFn: (payload: APIPayload) => sendMessage(payload),
    onSuccess: (data) => {
      console.log(data);
    },
    onError: (error) => {
      toast.error('Sending Message Failed', { description: error.message });
    },
  });
};
